import { Box } from '@mui/material'

type EllipsisCellProps = {
  children: React.ReactNode
  // full text for the hover tooltip; defaults to children when it is a string
  title?: string
}
/**
 * @description Keeps a custom-rendered DataGrid cell on one line and truncates it with an ellipsis, so long values
 * (dates, names) never spill into the neighboring column on narrow screens.
 */
const EllipsisCell = (props: EllipsisCellProps) => {
  const { children, title } = props
  return (
    <Box
      title={title ?? (typeof children === 'string' ? children : undefined)}
      sx={{ minWidth: 0, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}
    >
      {children}
    </Box>
  )
}
export default EllipsisCell
